export const ogrFrameMsg = (function(window, document) {

	let eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent',
		eventer = window[eventMethod],
		messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message',
		is_ready = false,
		id,
		source,
		origin,
		current_height;

	eventer(messageEvent, function(event) {
    let data = event.data;
		if (!data || data.length === 0 || typeof data != 'string') {
			return;
		}
		data = data.split('-');
		if (data.length !== 2) {
			return;
		}
		if (data[0] !== 'height') {
			return;
		}
		id = parseInt(data[1], 10);
		if (isNaN(id)) {
			id = undefined;
			return;
		}
		source = event.source;
		origin = event.origin;
		is_ready = true;
		sendPostMessage(Math.ceil(document.body.offsetHeight) + 1, false);
	}, false);

	function sendPostMessage(height, scroll) {
		if (!is_ready) {
			return;
		}
		if (typeof height === 'number') {
			current_height = height;
		}
		let sendString = id + '-' + current_height;
		if (typeof scroll === 'number') {
			sendString += '-' + scroll;
		}
		source.postMessage(sendString, origin);
	}

	return {
		send: function(height, scroll) {
			sendPostMessage(height, scroll);
		}
	};
})(window, document);



// WEBPACK FOOTER //
// ./src/modules/ogrFrameMsg.js